import Snackbar from '@mui/material/Snackbar';
import { COLLABORATOR_SYNC_ERROR_SNACKBAR_ID, useCollaboratorSyncError } from './collaboratorSyncErrorNotification';
import { bottomCenterSnackbarStackSx, centeredPlainSnackbarContentSx, mergeSx } from './snackbarStyles';

interface CollaboratorSyncErrorSnackbarProps {
  stackIndex: number;
}

const CollaboratorSyncErrorSnackbar = ({ stackIndex }: CollaboratorSyncErrorSnackbarProps) => {
  const syncError = useCollaboratorSyncError();

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={Boolean(syncError)}
      message={syncError}
      sx={bottomCenterSnackbarStackSx(stackIndex)}
      slotProps={{
        content: {
          id: COLLABORATOR_SYNC_ERROR_SNACKBAR_ID,
          role: 'alert',
          sx: mergeSx(centeredPlainSnackbarContentSx, (theme) => ({
            maxWidth: 320,
            backgroundColor: theme.vars?.palette?.background?.paper ?? theme.palette.background.paper,
            color: theme.vars?.palette?.error?.main ?? theme.palette.error.main,
          })),
        },
      }}
    />
  );
};

export default CollaboratorSyncErrorSnackbar;
